import { IconFont, pointer } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.div`
    max-height: inherit;
    overflow: auto;
    padding-bottom: 8px;
`

export const Tabs = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
    background: var(--color-gray-50);
`

export const TabPane = styled.div`
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid var(--color-gray-200);
    background: 'var(--color-gray-50)';
    color: var(--color-gray-400);
    box-sizing: border-box;
    ${pointer}
`

export const Icon = styled(IconFont)<{ color?: string }>`
    color: ${({ color }) => color || 'var(--color-white)'};
    /* color: '#2E90FA'; */
    /* color: red; */
`

export const Tab = styled.div`
    font-size: 14px;
    margin-left: 6px;
`

export const List = styled.div`
    /* padding: 0 16px; */
    /* height: 100%; */
    /* overflow: auto; */
    /* max-height: calc(100vh - 55px - 40px); */
`

export const Item = styled.div``

export const SelectItem = styled.div`
    height: 36px;
    padding: 0 16px;
    ${pointer};
    &:hover {
        background: #eceff4;
    }
`

export const SelectItemTitle = styled.div`
    font-size: 14px;
    margin-left: 8px;
    color: var(--color-gray-900);
`

export const TooltipContainer = styled.div`
    /* background: red; */
    padding: 0 16px;
`

export const TooltipDesc = styled.div`
    color: var(--color-gray-500);
    font-size: 12px;
    line-height: 20px;
    margin: 4px 0;
`

export const ItemIconOuter = styled.div<{ background?: string }>`
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background: ${({ background }) => background};
`
